import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=0678eedb&scoped=true&"
import script from "./Dashboards.vue?vue&type=script&lang=js&"
export * from "./Dashboards.vue?vue&type=script&lang=js&"
import style0 from "./Dashboards.vue?vue&type=style&index=0&id=0678eedb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678eedb",
  null
  
)

export default component.exports